<template>
    <div class="projects-dropdown" v-focus-outside="close" v-click-outside="close">
        <div tabindex="0" @click="open = !open" @keydown.enter="open = !open" class="font-size-huge dropdown"><b-icon><icon-chevron-down /></b-icon></div>
        <ul :class="{open}" class="bg-white-base border-top border-left border-right border-white-darker-3 elevation-4dp font-size-normal regular">
            <router-link tabindex="0" @click.native="open = false" @keydown.enter.native="$router.push(`/project/${project.id}`); open = false;" v-for="project in projects" :key="project.id" :to="`/project/${project.id}`" tag="li" class="bg-white-base border-bottom border-white-darker-3 bg-hover-white-darker-2 padding-vertical-normal padding-horizontal-big bg-focus-white-darker-2">{{ project.name }}</router-link>
            <!-- <li class="bg-white-base border-bottom border-white-darker-3 bg-hover-white-darker-2 padding-vertical-tiny padding-horizontal-normal" v-for="project in projects" :key="project.id"  @click="changeProject(project)">{{ project.name }}</li> -->
            <li tabindex="0" @click="addNewProject({name: 'Novo Projeto', releases: []})" @keydown.enter="addNewProject({name: 'Novo Projeto', releases: []})"  class="bg-white-base border-bottom border-white-darker-3 bg-hover-white-darker-2 padding-vertical-normal padding-horizontal-big bg-focus-white-darker-2">Adicionar novo..</li>
        </ul>
    </div>
</template>

<script>
import BIcon from '@/dls/components/Icon.vue';
import IconChevronDown from '@/dls/icons/icon-chevron-down.svg';
import ClickAndFocusOutside from '@/dls/mixins/ClickAndFocusOutside.js';
export default {
    name: 'ProjectsDropdown',
    mixins: [
        ClickAndFocusOutside
    ],
    components: {
        IconChevronDown, BIcon
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        addNewProject(project) {
            this.$store.dispatch('addProject', project).then((project) => {
                this.$router.push(`/project/${project.id}`);
                this.open = false;
            });
        },
        changeProject(project) {
            this.$router.push(`/project/${project.id}`);
        },
        close() {
            this.open = false;
        }
    },
    computed: {
        projects() {
            return this.$store.getters.projects;
        }
    },
    mounted() {
        // call para o back-end para obter array com projetos contendo id e name;
        if (typeof(Storage) !== "undefined" && window.localStorage.getItem('projects')) {
            var projects = JSON.parse(window.localStorage.getItem('projects'));
            var currentProjectId = this.$store.getters.currentProject.id;
            projects.map((project) => (delete project.releases));
            this.$store.commit('setProjects', {projects});
        }
    },
    // watch: {
    //     '$route.params.id': () => this.open = false
    // }
}
</script>

<style scoped lang="scss">
.projects-dropdown {
    position: relative;
    display: inline-block;
}
.dropdown {
    cursor: pointer;
}
ul {
    display: none;
    position: absolute;
    max-width: 350px;
    top: calc(100% + 4px);
    left: 0;
    border-radius: 5px;
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 10;
    li {
        cursor: pointer;
        white-space: nowrap;
    }
}
ul.open {
    display: block;
}
</style>